const items = [
  {
    name: "factory1",
    image: require("../assets/images/slider/gate2.jpg"),
  },

  {
    name: "factory2",
    image: require("../assets/images/slider/factory5.jpg"),
  },

  {
    name: "machine",
    image: require("../assets/images/slider/machineBig.webp"),
  },
  {
    name: "cmmachine",
    image: require("../assets/images/slider/smallMachine.webp"),
  },
  {
    name: "caps1",
    image: require("../assets/images/slider/DSC_2421.webp"),
  },
  {
    name: "caps2",
    image: require("../assets/images/slider/DSC_2425.webp"),
  },
];
export default items;
